export default __webpack_public_path__ + "static/media/logo-blue.fff401c7.svg";